import { ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";

// Simple RSTI signal only. No score, no level, no ranking shown publicly.
export default function VerifiedBadge({ verified, level, size = "sm" }) {
  const { lang } = useLang();
  const isVerified = verified !== undefined ? verified : (level === "verified" || level === "premium");
  if (!isVerified) return null;
  return (
    <span
      data-testid="rst-verified-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border border-champagne/30 bg-champagne/10 px-2.5 py-1 text-xs font-medium text-champagne ${size === "lg" ? "text-sm px-3 py-1.5" : ""}`}
    >
      <ShieldCheck className="h-3.5 w-3.5" strokeWidth={1.75} />
      {lang === "fr" ? "Vérifié par RSTI" : "Verified by RSTI"}
    </span>
  );
}
